<template>
    <div>
        <gobuy-head title="Card Details" />
        <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
        <div class="box">
            <div class="headers">
                <img :src="infos.image" >
                <div class="headers_list1">
                    <div class="headers_list1_txt1">{{$t('Original Price')}} {{infos.usd}}</div>
                    <div class="headers_list1_txt2">{{$t('Discount')}} {{infos.dicount*10}}%</div>
                </div>
                <div class="headers_list1">
                    <div class="headers_list1_txt1">{{$t('Actual Payment')}}</div>
                    <div class="headers_list1_txt3">{{(Number(infos.usd) * Number(infos.dicount) /10).toFixed(2)}}</div>
                </div>
            </div>
            <!-- 
                <div class="made1">
                <div class="mead1_txt">Cryptocurrency payments</div>
                <img src="../../../assets/image/giftcard/giftcardicons1.png">
            </div> -->
        
            <div class="btn1">{{$t('Balance')}} {{available_predeposit}}</div>
            <div class="btn1" style="background: #e2b72c;position: relative;" v-if="infos.type == 2">
                Gold Card Balance: {{gold_card_balance}}
                <div class="btn1-transfer" @click="transfer"><svg t="1765609023484" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4764" width="30" height="30"><path d="M513.31 510.04m-446.72 0a446.72 446.72 0 1 0 893.44 0 446.72 446.72 0 1 0-893.44 0Z" fill="#e2b72c" p-id="4765" data-spm-anchor-id="a313x.search_index.0.i0.101e3a81lcAaGp" class="selected"></path><path d="M576.88 752.82c-15.21 0-27.56-12.34-27.56-27.56V288.07c0-15.21 12.34-27.56 27.56-27.56s27.56 12.34 27.56 27.56v437.19c-0.01 15.21-12.35 27.56-27.56 27.56z" fill="#FFFFFF" p-id="4766"></path><path d="M576.88 752.82c-7.05 0-14.1-2.69-19.48-8.07-10.76-10.76-10.76-28.2 0-38.96l130.04-130.03c10.76-10.76 28.2-10.76 38.96 0 10.76 10.76 10.76 28.2 0 38.97L596.36 744.74c-5.38 5.39-12.43 8.08-19.48 8.08z" fill="#FFFFFF" p-id="4767"></path><path d="M449.74 752.82c-15.21 0-27.56-12.34-27.56-27.56V288.07c0-15.21 12.34-27.56 27.56-27.56 15.21 0 27.56 12.34 27.56 27.56v437.19c0 15.21-12.35 27.56-27.56 27.56z" fill="#FFFFFF" p-id="4768"></path><path d="M319.7 445.67c-7.05 0-14.1-2.69-19.48-8.07-10.76-10.76-10.76-28.2 0-38.96L430.26 268.6c10.76-10.76 28.2-10.76 38.96 0 10.76 10.76 10.76 28.2 0 38.96L339.18 437.6a27.463 27.463 0 0 1-19.48 8.07z" fill="#FFFFFF" p-id="4769"></path></svg></div>
            </div>
            <div class="btn2" @click="showModel = true">{{$t('Buy now')}}</div>

            <div class="model" v-if="showModel">
                <div class="model_box">
                    <div class="model_box_tit">{{$t('MessageBox.Tips')}}</div>
                    <div class="model_box_txt">{{$t('MessageBox.buy.card')}}</div>
                    <div class="model_box_foot">
                        <div class="box_foot_lf" @click="showModel = false">{{$t('MessageBox.Cancel')}}</div>
                        <div class="box_foot_rt" @click="buys">{{$t('MessageBox.Confirm')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast,Indicator,MessageBox } from "mint-ui";
import { buyGiftCard } from '../../../api/giftcard'
import { getMemberIndex,goldTransfer } from '../../../api/member'
export default {
  name: 'GiftCardDetails',
  data () {
    return {
     showModel:false,
     infos:{},
     available_predeposit: '0.00',
     gold_card_balance: '0.00',
    }
  },
  mounted(){
    this.infos = JSON.parse(this.$route.query.data)
    getMemberIndex().then(
        response => {
            if (response && response.result.member_info) {
                this.available_predeposit = response.result.member_info.available_predeposit
                this.gold_card_balance = response.result.member_info.gold_card_balance
            }
        },
    )
  },
  methods: {
    buys(){
        // const usd = (Number(this.infos.usd) * Number(this.infos.dicount) /10).toFixed(2)
        // if(this.infos.type == 2 && usd > this.gold_card_balance){
        //     Indicator.close();
        //     Toast('Insufficient gold card balance');
        //     this.showModel = false
        //     return;
        // }else if(this.infos.type == 1 && usd > this.available_predeposit){
        //     Indicator.close();
        //     Toast('Insufficient balance');
        //     this.showModel = false
        //     return;
        // }
        Indicator.open();
        buyGiftCard({usd:this.infos.usd, type: this.infos.type}).then(res=>{
            Indicator.close();
            this.showModel = false
            if(res.code == 10000){
                this.$router.push({ 'name': 'MyCardList', 'query': { 'type':this.infos.type } })
            } else {
                Toast(res.message);
            }
        }).catch(function (error) {
          Indicator.close();
          this.showModel = false
          Toast(error.message);
        });
    },
    transfer(){
        let that = this;
        MessageBox({
            $type: "prompt",
            title: 'Transfer Amount to Gold Card Balance',
            message: 'Please enter the amount you wish to transfer',
            confirmButtonText: that.$t("MessageBox.Confirm"),
            cancelButtonText: that.$t("MessageBox.Cancel"),
            showCancelButton: true,
            showInput: true
        }).then(({ value, action }) => {
            if (action == "confirm") {
                Indicator.open();
                goldTransfer(value).then((res) => {
                    Indicator.close();
                    Toast(res.message);
                    if (res.code == 10000) {
                        this.available_predeposit = ((Number(this.available_predeposit) || 0) - (Number(value) || 0)).toFixed(4)
                        this.gold_card_balance = ((Number(this.gold_card_balance) || 0) + (Number(value) || 0)).toFixed(4)
                    }
                }).catch(function (error) {});
            }
        }).catch(() => {});
    }
  }
}
</script>
<style>
.mint-toast-text{
    white-space: pre-line;
    text-align: left;
}
</style>
<style scoped lang="scss">
.model{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.7);
    z-index: 99;
    .model_box{
        width: 80%;
        position: absolute;
        top: 50%;
        left: 10%;
        height: 300px;
        margin-top: -150px;
        background: #FFFFFF;
        border-radius: 15px;
        .model_box_tit{
            text-align: center;
            font-weight: bold;
            font-size: 23px;
            line-height: 90px;
            color: #171616;
        }
        .model_box_txt{
            color: #000000;
            line-height: 40px;
            width: 80%;
            margin:10px auto 30px;
        }
        .model_box_foot{
            display: flex;
            justify-content: space-between;
            padding: 0 10%;
            width: 100%;
            box-sizing: border-box;
            .box_foot_lf{
                min-width: 40%;
                height: 43px;
                line-height: 43px;
                background: #989898;
                border-radius: 6px;
                font-size: 18px;
                text-align: center;
                color: #FFFFFF;
            }
            .box_foot_rt{
                min-width: 40%;
                height: 43px;
                line-height: 43px;
                background: #EF4618;
                border-radius: 6px;
                font-size: 18px;
                text-align: center;
                color: #FFFFFF;
                
            }
        }
    }
}
.box{
    width: 100%;
    overflow: hidden;
    height: 85vh;
    overflow-y: auto;
    .headers{
        width: 100%;
        background: linear-gradient( 180deg, #FFFAF8 0%, #FFD7C5 100%);
        box-shadow: 2px 6px 8px 1px rgba(80,43,0,0.09), inset 0px -1px 4px 1px #FFFFFF;
        padding: 50px 0;
        img{
            width: 15rem;
            object-fit: contain;
            margin: 0 auto 20px;
            display: block;
        }
        .headers_list1{
            display: flex;
            padding: 0 30px;
            justify-content: space-between;
            .headers_list1_txt1{
                font-size: 14px;
                color: #000000;
                line-height: 39px;
            }
            .headers_list1_txt2{
                padding: 0 20px;
                height: 28px;
                line-height: 28px;
                font-size: 14px;
                text-align: center;
                color: #FFFFFF;
                background: #E2B72B;
                border-radius: 30px;
            }
            .headers_list1_txt3{
                font-size: 20px;
                color: #000000;
                line-height: 39px;
                margin-right: 20px;
            }
        }
    }
    .made1{
        display: flex;
        justify-content: space-between;
        padding: 50px 30px;
        .made1_txt{
            font-size: 14px;
            color: #000000;
            line-height: 39px;
        }
        img{
            width: 25px;
            height: 25px;
        }
    }
    .btn1{
        width: 60%;
        height: 32px;
        background: #EF4618;
        border-radius: 16px;
        line-height: 32px;
        font-size: 14px;
        text-align: center;
        color: #FFFFFF;
        margin: 30px auto 10px;
    }
    .btn1-transfer{
        position: absolute;
        right: -20%;
        top: -30%;
        transform: translateY(-50%);
    }
    .btn2{
        width: 60%;
        height: 43px;
        background: #EF4618;
        border-radius: 6px;
        line-height: 43px;
        font-size: 18px;
        text-align: center;
        color: #FFFFFF;
        margin: 50px auto 80px;
    }
}
</style>
